import { Text, View } from "@react-pdf/renderer";
import { remainingTimeInPeriod } from "../functions/Helper.js";

function getTime(totalSeconds) {
  totalSeconds = Math.round(totalSeconds);
  let seconds = totalSeconds % 60;
  let minutes = Math.floor(totalSeconds / 60);
  return minutes + ":" + seconds.toString().padStart(2, "0");
}

export default function Ruler(props) {
  const getArray = () => {
    let array = [];
    for (let i = props.start; i <= props.end; i += 60) {
      array.push(i);
    }
    return array;
  };

  return (
    <View
      style={{
        marginLeft: 0,
        marginBottom: 8,
        position: "relative",
        height: "5px",
      }}
    >
      {getArray()
        .map((x) => remainingTimeInPeriod(x, props.start, props.end))
        .map((x) => getTime(x))
        .map((x, index) => {
          return (
            <View
              style={{
                position: "absolute",
                left: (index / (getArray().length - 1)) * 100 + "%",
              }}
              key={index}
            >
              <View
                style={{
                  width: 20,
                  marginLeft: -10,
                  fontSize: 6,
                  fontWeight: 500,
                  color: "#333",
                }}
              >
                <Text style={{ width: 20, textAlign: "center" }}>{x}</Text>
              </View>
              <View
                key={index}
                style={{
                  borderLeft: "1px solid #000000",
                  height: 3,
                }}
              />
            </View>
          );
        })}
    </View>
  );
}
